// src/components/DateFilter.js
import React from "react";
import { Row, Col, Form } from "react-bootstrap";
import CustomButton from "../button/index";
import { TbFilterSearch } from "react-icons/tb";
import { TbZoomReset } from "react-icons/tb";

const DateFilter = ({ 
  fromDate, 
  toDate, 
  setFromDate, 
  setToDate, 
  handleFilter, 
  handleReset, 
  showApplyButton = true // Default to true
}) => {
  const today = new Intl.DateTimeFormat('en-CA', { 
    timeZone: 'Asia/Dubai', 
    year: 'numeric', 
    month: '2-digit', 
    day: '2-digit' 
  }).format(new Date()).split("-").join("-");
  
  
  return (
    <Row className="mb-4">
      <Col md={4}>
        <Form.Group controlId="fromDate">
          <Form.Label>From Date</Form.Label>
          <Form.Control
            type="date"
            value={fromDate}
            max={today} // Allow only dates up to today
            onChange={(e) => setFromDate(e.target.value)}
          />
        </Form.Group>
      </Col>
      <Col md={4}>
        <Form.Group controlId="toDate">
          <Form.Label>To Date</Form.Label>
          <Form.Control
            type="date"
            value={toDate}
            max={today} // Allow only dates up to today
            onChange={(e) => setToDate(e.target.value)}
          />
        </Form.Group>
      </Col>
      <Col md={4} className="d-flex align-items-end">
        <div className="d-flex gap-2">
          {showApplyButton && (
            <CustomButton variant="primary" onClick={handleFilter}>
              <TbFilterSearch/><div className='ml-3'>Apply Filter</div>
            </CustomButton>
          )}
          <CustomButton variant="secondary" onClick={handleReset}>
           <TbZoomReset /><div className='ml-3'>Reset</div> 
          </CustomButton>
        </div>
      </Col>
    </Row>
  );
};

export default DateFilter;
